import Layout from '../layout/Layout.vue'
import {createRouter, createWebHistory} from "vue-router";


export const constantRoutes = [
    {path: '/', redirect: '/Login'},
    {path: '/Login', name: 'Login', component: () => import("@/views/Login")},
    {path: '/login', redirect: '/Login'},
    {
        path: '/Layout', name: 'Layout', component: Layout, children: [
            //
            {path: '/home', name: 'Home', component: () => import("@/views/Home")},
            {path: '/stuInfo', name: 'StuInfo', component: () => import("@/views/StuInfo")},
            {path: '/dormManagerInfo', name: 'DormManagerInfo', component: () => import("@/views/DormManagerInfo")},
            {path: '/buildingInfo', name: 'BuildingInfo', component: () => import("@/views/BuildingInfo")},
            {path: '/roomInfo', name: 'RoomInfo', component: () => import("@/views/RoomInfo")},
            {path: '/roomPanel', name: 'RoomPanel', component: () => import("@/views/RoomPanel")},
            {path: '/roomStatus', name: 'RoomStatus', component: () => import("@/views/RoomStatus")},
            {path: '/roomCalendar', name: 'RoomCalendar', component: () => import("@/views/RoomCalendar")},
            {path: '/roomBooking', name: 'RoomBooking', component: () => import("@/views/RoomBooking")},
            {path: '/classInfo', name: 'ClassInfo', component: () => import("@/views/ClassInfo")},
            {path: '/noticeInfo', name: 'NoticeInfo', component: () => import("@/views/NoticeInfo")},
            {path: '/adjustRoomInfo', name: 'AdjustRoomInfo', component: () => import("@/views/AdjustRoomInfo")},
            {path: '/repairInfo', name: 'RepairInfo', component: () => import("@/views/RepairInfo")},
            {path: '/visitorInfo', name: 'VisitorInfo', component: () => import("@/views/VisitorInfo")},
            {path: '/materiel', name: 'Materiel', component: () => import("@/views/Materiel.vue")},
            //
            {path: '/myRoomInfo', name: 'MyRoomInfo', component: () => import("@/views/MyRoomInfo")},
            {path: '/applyRepairInfo', name: 'ApplyRepairInfo', component: () => import("@/views/ApplyRepairInfo")},
            {path: '/applyChangeRoom', name: 'ApplyChangeRoom', component: () => import("@/views/ApplyChangeRoom")},
            {path: '/changeRoomApproval', name: 'ChangeRoomApproval', component: () => import("@/views/ChangeRoomApproval")},
            {path: '/approverInfo', name: 'ApproverInfo', component: () => import("@/views/ApproverInfo")},
            {path: '/dataBackup', name: 'DataBackup', component: () => import("@/views/DataBackup")},

            {path: '/selfInfo', name: 'SelfInfo', component: () => import("@/views/SelfInfo")},
        ]
    },

]
const router = createRouter({
    routes: constantRoutes,
    history: createWebHistory(process.env.BASE_URL)
})
//路由守卫
router.beforeEach((to, from, next) => {
    //to 要访问的路径
    //from 代表从哪个路径跳转而来
    // next 是函数，表示放行
    // next() 放行
    // next('/*') 强制跳转
    const user = window.sessionStorage.getItem('user')
    if (to.path === '/Login') {
        return next();
    }
    if (!user) {
        return next('/Login')
    }
    if (to.path === '/' && user) {
        return next('/home')
    }
    next()
})

export default router
